import { Arr, ListStore, memone } from '@deqo/foundation';
import { injectable } from 'inversify';
import { Overlay } from './Overlay';

@injectable()
export class OverlayComposition extends ListStore<Overlay> {

    private get index() {
        return this.buildIndexById(this.getState());
    }

    public get(id: string) {
        return this.index.get(id) || null;
    }

    public add(overlay: Overlay) {
        if (this.get(overlay.id)) return false;
        this.updateState(x => x.push(overlay));
        return true;
    }

    public remove(overlay: Overlay) {
        if (!this.get(overlay.id)) return false;
        this.updateState(x => Arr.remove(x, overlay));
        return true;
    }

    @memone()
    private buildIndexById(state: Overlay[]) {
        return new Map(state.map(x => [x.id, x]));
    }
}
